import { put } from "redux-saga/effects";
import { begin, end, pendingTask } from "react-redux-spinner";

import { IGetUsers, getUsersResponse } from "../admin.actions";
import AdminService from "../admin.service";
import AdminFeedback from "../admin.feedback";

export function* getUsersSaga(action: IGetUsers) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  const { activeOnly, searchText, skip, reverseOrder, sort } = action.payload;

  try {
    const service = new AdminService();
    const users = yield service.getUsers(
      skip,
      searchText,
      activeOnly,
      sort,
      reverseOrder
    );
    yield put(getUsersResponse(users));
  } catch (error) {
    yield put(getUsersResponse(error, AdminFeedback.USER_LIST_FAILED));
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}
